import {
  IBackendRes,
  IAccount,
  IUser,
  IModelPaginate,
  IGetAccount,
  IPost,
  ICategory,
  ITopic,
  createPost,
  createCategory,
  IRole,
  IPermission,
  updateStatusUser,
} from "../types/backend";
import axios from "./axios-customize";

/**
 * 
API Auth
 */
export const callRegister = (
  name: string,
  email: string,
  password: string,
  age: number,
  gender: string,
  address: string,
  avatar: string,
  status: boolean
) => {
  return axios.post<IBackendRes<IUser>>("/api/v1/auth/register", {
    name,
    email,
    password,
    age,
    gender,
    address,
    avatar,
    status,
  });
};

export const callLogin = (username: string, password: string) => {
  return axios.post<IBackendRes<IAccount>>("/api/v1/auth/login", {
    username,
    password,
  });
};

export const callFetchAccount = () => {
  return axios.get<IBackendRes<IGetAccount>>("/api/v1/auth/account");
};

export const callRefreshToken = () => {
  return axios.get<IBackendRes<IAccount>>("/api/v1/auth/refresh");
};

export const callLogout = () => {
  return axios.post<IBackendRes<string>>("/api/v1/auth/logout");
};

/**
 * Upload single file
 */
export const callUploadSingleFile = (file: any, folderType: string) => {
  const bodyFormData = new FormData();
  bodyFormData.append("fileUpload", file);
  return axios<IBackendRes<{ fileName: string }>>({
    method: "post",
    url: "/api/v1/files/upload",
    data: bodyFormData,
    headers: {
      "Content-Type": "multipart/form-data",
      folder_type: folderType,
    },
  });
};

/**
 * 
API User
 */
export const callCreateUser = (user: IUser) => {
  return axios.post<IBackendRes<IUser>>("/api/v1/users", { ...user });
};

export const callUpdateUser = (user: IUser) => {
  return axios.patch<IBackendRes<IUser>>(`/api/v1/users`, { ...user });
};

export const callUpdateStatusUser = (user: updateStatusUser) => {
  return axios.put<IBackendRes<updateStatusUser>>(
    `/api/v1/users/update-status`,
    {
      ...user,
    }
  );
};

export const callDeleteUser = (id: string) => {
  return axios.delete<IBackendRes<IUser>>(`/api/v1/users/${id}`);
};

export const callFetchUser = (query: string) => {
  return axios.get<IBackendRes<IModelPaginate<IUser>>>(
    `/api/v1/users?${query}`
  );
};

export const callFetchUserByID = (id: string) => {
  return axios.get<IBackendRes<IUser>>(`/api/v1/users/${id}`);
};

export const callUpdateUserInfo = (user: any) => {
  return axios.put("/api/v1/users/update-user-info", { ...user });
};
export const callUpdatePassword = (
  oldPassword: string,
  newPassword: string
) => {
  return axios.put("/api/v1/users/reset-password", {
    oldPassword,
    newPassword,
  });
};

/**
API Post
*/

export const callFetchPost = (query: string) => {
  return axios.get<IBackendRes<IPost>>(`/api/v1/posts?${query}`);
};

export const callCreatePost = (createPost: createPost) => {
  return axios.post<IBackendRes<IPost>>(`api/v1/posts`, { ...createPost });
};

export const callDeletePost = (id: string) => {
  return axios.delete<IBackendRes<IPost>>(`api/v1/posts/${id}`);
};

export const callUpdatePost = (id: string, updatePost: createPost) => {
  return axios.patch<IBackendRes<IPost>>(`api/v1/posts/${id}`, {
    ...updatePost,
  });
};

export const callFetchPostByID = (id: string) => {
  return axios.get<IBackendRes<IPost>>(`api/v1/posts/${id}`);
};

export const callLikePost = (postId: string) => {
  return axios.put<IBackendRes<IPost>>(`api/v1/posts/${postId}`);
};

// API Upload
export const callFetchUpload = (query: string) => {
  return axios.get<IBackendRes<any>>(`/api/v1/upload?${query}`);
};

export const callCreateUpload = (image: any) => {
  return axios.post<IBackendRes<any>>(`/api/v1/upload`, {
    image: image,
  });
};

export const callDeleteUpload = (body: any) => {
  return axios.delete<any>(`/api/v1/upload`, {
    data: body,
  });
};

export const callUpdateUpload = (body: any) => {
  return axios.put<any>(`/api/v1/upload`, {
    ...body,
  });
};

// API Category
export const callFetchCategory = (query: string) => {
  return axios.get<IBackendRes<ICategory>>(`/api/v1/category?${query}`);
};

export const callFetchCategoryByID = (id: string) => {
  return axios.get<IBackendRes<ICategory>>(`/api/v1/category/${id}`);
};

export const callCreateCategory = (createCategory: createCategory) => {
  return axios.post<IBackendRes<ICategory>>(`/api/v1/category`, {
    ...createCategory,
  });
};

export const callDeleteCategory = (id: string) => {
  return axios.delete<IBackendRes<ICategory>>(`/api/v1/category/${id}`);
};

export const callUpdateCategory = (
  id: string,
  updateCategory: createCategory
) => {
  return axios.patch<IBackendRes<ICategory>>(`/api/v1/category/${id}`, {
    ...updateCategory,
  });
};

// API Topic
export const callFetchTopic = (query: string) => {
  return axios.get<IBackendRes<ITopic>>(`/api/v1/topic?${query}`);
};

export const callCreateTopic = () => {
  return axios.post<IBackendRes<ITopic>>(`/api/v1/topic`, {});
};

export const callUpdateTopic = (id: string, updateTopic: any) => {
  return axios.patch<IBackendRes<ITopic>>(`/api/v1/topic/${id}`, {
    ...updateTopic,
  });
};

export const callDeleteTopic = (id: string) => {
  return axios.delete<IBackendRes<ITopic>>(`/api/v1/topic/${id}`);
};

export const callFetchTopicByID = (id: string) => {
  return axios.get<IBackendRes<ITopic>>(`/api/v1/topic/${id}`);
};

// API Role
export const callFetchRole = (query: string) => {
  return axios.get<IBackendRes<IRole>>(`/api/v1/roles?${query}`);
};

export const callCreateRole = (createRole: IRole) => {
  return axios.post<IBackendRes<IRole>>(`/api/v1/roles`, {
    ...createRole,
  });
};

export const callUpdateRole = (id: string, updateRole: any) => {
  return axios.patch<IBackendRes<IRole>>(`/api/v1/roles/${id}`, {
    ...updateRole,
  });
};

export const callDeleteRole = (id: string) => {
  return axios.delete<IBackendRes<IRole>>(`/api/v1/roles/${id}`);
};

export const callFetchRoleByID = (id: string) => {
  return axios.get<IBackendRes<IRole>>(`/api/v1/roles/${id}`);
};

// API Podcast
export const callFetchPodcast = (query: string) => {
  return axios.get<IBackendRes<any>>(`/api/v1/podcast?${query}`);
};

export const callCreatePodcast = (createPodcast: any) => {
  return axios.post<IBackendRes<any>>(`/api/v1/podcast`, {
    ...createPodcast,
  });
};

export const callUpdatePodcast = (id: string, updatePodcast: any) => {
  return axios.patch<IBackendRes<any>>(`/api/v1/podcast/${id}`, {
    ...updatePodcast,
  });
};

export const callDeletePodcast = (id: string) => {
  return axios.delete<IBackendRes<any>>(`/api/v1/podcast/${id}`);
};

export const callFetchPodcastByID = (id: string) => {
  return axios.get<IBackendRes<any>>(`/api/v1/podcast/${id}`);
};

/**
 * 
API Permission
 */
export const callCreatePermission = (permission: IPermission) => {
  return axios.post<IBackendRes<IPermission>>("/api/v1/permissions", {
    ...permission,
  });
};

export const callUpdatePermission = (permission: IPermission, id: string) => {
  return axios.patch<IBackendRes<IPermission>>(`/api/v1/permissions/${id}`, {
    ...permission,
  });
};

export const callDeletePermission = (id: string) => {
  return axios.delete<IBackendRes<IPermission>>(`/api/v1/permissions/${id}`);
};

export const callFetchPermission = (query: string) => {
  return axios.get<IBackendRes<IModelPaginate<IPermission>>>(
    `/api/v1/permissions?${query}`
  );
};

export const callFetchPermissionById = (id: string) => {
  return axios.get<IBackendRes<IPermission>>(`/api/v1/permissions/${id}`);
};

// API Comments
export const callCreateComment = (comment: any) => {
  return axios.post<IBackendRes<IPermission>>("/api/v1/comments", {
    ...comment,
  });
};

export const callFetchComment = (query: string) => {
  return axios.get<IBackendRes<IModelPaginate<IPermission>>>(
    `/api/v1/comments?${query}`
  );
};

// API Dashboard
export const callFetchDashboard = () => {
  return axios.get<IBackendRes<any>>("/api/v1/dashboard");
};

// API Email Follow
export const callFetchEmailFollow = (query: any) => {
  return axios.get<IBackendRes<any>>(`/api/v1/email-follow?${query}`);
};

export const callCreateEmailFollow = (values: any) => {
  return axios.post<IBackendRes<IPermission>>("/api/v1/email-follow", {
    ...values,
  });
};

export const callUpdateEmailFollow = (id: string, values: any) => {
  return axios.patch<IBackendRes<IPermission>>(`/api/v1/email-follow/${id}`, {
    ...values,
  });
};

export const callDeleteEmailFollow = (id: string) => {
  return axios.delete<IBackendRes<IPermission>>(`/api/v1/email-follow/${id}`);
};

export const callFetchEmailFollowById = (id: string) => {
  return axios.get<IBackendRes<IPermission>>(`/api/v1/email-follow/${id}`);
};

// Module send email
export const callFetchSendEmail = () => {
  return axios.get<IBackendRes<any>>(`/api/v1/mail`);
};
